import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FaecesSampleAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-faeces-sample-slot',
    templateUrl: './faeces-sample-slot.component.html',
    styleUrl: './faeces-sample-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaecesSampleSlotComponent implements SheetSlotComponentBase {

	@Input() action!: FaecesSampleAction;
	value = null;

	constructor() {
	}
}